
    import React from 'react';
    import { useAuth } from '@/contexts/AuthContext';
    import { Button } from '@/components/ui/button';
    import { AlertCircle, Loader2 } from 'lucide-react';
    import { motion, AnimatePresence } from 'framer-motion';

    const EmailConfirmationBanner = () => {
      const { user, isEmailConfirmed, loading, resendConfirmationEmail, isLoadingAuthAction } = useAuth();

      const handleResend = () => {
         if (user?.email) {
            resendConfirmationEmail(user.email);
         }
      };

      // Don't show if loading, no user, or email is confirmed
      const shouldShow = !loading && user && !isEmailConfirmed;

      return (
         <AnimatePresence>
            {shouldShow && (
               <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className="bg-yellow-100 border-b border-yellow-300 text-yellow-800"
                  role="alert"
               >
                  <div className="container py-2 px-4 flex items-center justify-between gap-4">
                     <div className="flex items-center gap-2">
                        <AlertCircle className="h-5 w-5 flex-shrink-0" />
                        <p className="text-sm font-medium">
                           Please confirm your email address. Check your inbox (and spam folder) for the confirmation link.
                        </p>
                     </div>
                     <Button
                        variant="link"
                        size="sm"
                        onClick={handleResend}
                        disabled={isLoadingAuthAction}
                        className="text-yellow-900 hover:text-yellow-700 whitespace-nowrap px-1"
                     >
                        {isLoadingAuthAction ? (
                           <Loader2 className="mr-1 h-4 w-4 animate-spin" />
                        ) : null}
                        Resend Email
                     </Button>
                  </div>
               </motion.div>
            )}
         </AnimatePresence>
      );
    };

    export default EmailConfirmationBanner;
  